module.exports = __webpack_public_path__ + "img/2.06f81152.jpg";